import styles from "./styles.module.scss";
import classNames from "classnames";
import React from "react";

type InstallationCardProps = {
  style?: string, 
  children: React.ReactNode,
  className?: string,
}

const InstallationCard = ({ style, children, className }: InstallationCardProps) => {
  return (
    <div className={classNames(styles.card, style, className)}>{children}</div>
  );
};

export default InstallationCard;
